import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Alert1 Privacy Policy</h1>
        
        <p>
          This website is administered by AlertOne Services, LLC. Alert1 is committed to protecting the privacy of any personally 
          identifiable information you share with us and to informing you about how we will use your personal data. Therefore, we 
          encourage you to read this Privacy Policy carefully.
        </p>

        <p>
          Information on Alert-1.com is gathered in two ways: (1) indirectly (for example, through our site's technology); and (2) 
          directly (for example, when you provide information on various pages of Alert-1.com).
        </p>

        <h2>Cookies and Visitor Information</h2>
        
        <p>
          The Alert-1.com web site will send a "cookie," a small text file, to your computer. If you visit Alert-1.com to browse, 
          read, or download information, we collect and store some "visitor information" from you, such as the name of the domain 
          and host from which you access the Internet, the Internet Protocol (IP) address of the computer you are using, the date 
          and time you access our Web Site, and the Internet address of the website from which you linked directly to our Web Site.
        </p>

        <p>
          We use this information to measure the traffic on our Web Site with Google analytics and to help us make our Web Site more 
          useful. We may also use this information for retargeting, which is a form of online advertising that delivers specific ads 
          to consumers based on their previous online actions through Google Adwords or Doubleclick for advertisers. We delete "visitor 
          information" periodically.
        </p>

        <p>
          If you do not wish to receive cookies, please refer to the "Help" file of your Internet Browser to learn how to either block 
          cookies or receive a warning before a cookie is stored. To opt out of Google Analytics for Display Advertisers or to opt out 
          of customized Google Display Network ads, you may visit the Ads Preferences Manager.
        </p>

        <p>
          Additionally, we collect information through our Internet access logs. When you access Alert-1.com, your IP address is 
          automatically collected and is placed in our Internet access logs.
        </p>

        <h2>Personal Information Collection</h2>
        
        <p>
          We also collect information when you voluntarily submit it to us. There are portions of this Web site where we may need to 
          collect personal information from you for a specific purpose, such as to provide you with information you request or to 
          deliver emergency monitoring services to our subscribers. The information collected from you may include your name, address, 
          phone numbers, date of birth, or e-mail address, as well as the names and phone numbers of personal emergency contacts.
        </p>

        <p>
          When we collect this type of information, we will notify you as to why we are asking for information and how this information 
          will be used. <strong>We will not sell your information and we will not send you unsolicited email.</strong>
        </p>

        <h2>Updating Your Information</h2>
        
        <p>
          If you are an existing customer and want to update the Personally Identifiable Information that you have provided to us, you 
          may update or delete this information 24 hours a day by visiting <Link to="/my-account">My Account</Link> or call Alert1 
          during business hours at 1-800-693-5433.
        </p>

        <h2>Refer-a-Friend</h2>
        
        <p>
          If you choose to use our "refer-a-friend to Alert1" option, we will ask you for your friend's name and email address. This 
          process will automatically send your friend a one-time email inviting him or her to learn more about Alert1 medical alarm 
          systems. Alert1 stores this information for the sole purpose of sending this one-time email, after which the names collected 
          are removed from our database.
        </p>

        <h2>Surveys and Contests</h2>
        
        <p>
          We may occasionally request information from you via surveys or contests. Your participation in these surveys or contests is 
          completely voluntary. The information that we request typically includes your contact details. If you choose to participate, 
          the information that you provide will be shared with the contest/survey sponsors to notify winners and award prizes. Survey 
          information may also be used to monitor and improve the content and performance of the Site.
        </p>

        <h2>Third-Party Links</h2>
        
        <p>
          Alert1's Web site contains links to other sites such as news sources, partners and sales affiliates. The information practices 
          of those websites are not covered by this privacy policy. We are not responsible for the privacy policies of websites to which 
          the Site links. If you provide any information to such third parties, different rules regarding the collection and use of your 
          personal information may apply.
        </p>

        <h2>Your Rights</h2>
        
        <p>
          You are entitled to have access to your information and to have it corrected if it is inaccurate.
        </p>

        <p>
          <strong>Please check this privacy policy periodically to stay informed of any changes.</strong>
        </p>

        <p className="legal-last-updated">
          Last Updated: October 2025
        </p>

        <div className="legal-footer-links">
          <Link to="/">Return to Home</Link>
          <Link to="/terms">Terms & Conditions</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;

